module.exports = __webpack_public_path__ + "img/boom1.bbce9bd4.jpg";